module.exports = __webpack_public_path__ + "static/media/ppicon.5e6c87c2.svg";